
<template>
  <div class="main-content">
    <Container
      :title="t('route.templateCategoryUser')"
      :hasLine="true"
    >
      <template #header>
        <SearchForm
          ref="searchFormRef"
          :formModel="searchFormModel"
          :formStruct="searchFormStruct"
          :submitButton="t('common.search')"
          :resetButton="t('common.reset')"
          @submit="submitSearch"
          @reset="resetForm"
        />
      </template>
      <template #main>
        <el-button
          v-if="this.$hasPermission(['ACTION_vcTemplateCategoryUserEdit'])"
          @click="handleCreate()"
          type="success"
        >
          {{ t('table.add') }}
        </el-button>
        <el-button
          v-if="selection.length > 0 && this.$hasPermission(['ACTION_vcTemplateCategoryUserEdit'])"
          @click="handleBathDelete()"
          type="danger"
        >
          {{ t('table.bathDelete') }}
        </el-button>
        <SimpleTable
          :isLoading="listLoading"
          :tableData="tableData"
          :columnStruct="columnStruct"
          :sort="sort"
          :order="order"
          @handleOrder="handleOrder"
          @handleSelection="handleSelection"
        >
          <template
            v-if="this.$hasPermission(['ACTION_vcTemplateCategoryUserEdit'])"
            #default="slotProps"
          >
            <el-button
              @click="handleEdit(slotProps.row)"
              type="primary"
              size="mini"
            >
              {{ t('common.edit') }}
            </el-button>
            <el-button
              @click="handleDelete(slotProps.row.id)"
              type="danger"
              size="mini"
            >
              {{ t('common.delete') }}
            </el-button>
          </template>
        </SimpleTable>
        <el-pagination
          :total="total"
          v-show="total > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          :current-page="page"
          :page-sizes="[5, 10, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right;"
        />
      </template>
    </Container>
    <el-dialog
      v-if="this.$hasPermission(['ACTION_vcTemplateCategoryUserEdit'])"
      :title="t(textMap[dialogStatus])"
      center
      v-model="dialogFormVisible"
      width="45%"
    >
      <NomalContainer>
        <CenterForm
          v-if="dialogStatus === 'create'"
          :formModel="createModel"
          :formStruct="createStruct"
          :formRules="templateCategoryUserRole"
          @submit="createSubmit"
          @reset="createReset"
        />
        <CenterForm
          v-if="dialogStatus === 'update'"
          :formModel="updateModel"
          :formStruct="updateStruct"
          :formRules="templateCategoryUserRole"
          @submit="updateNameSubmit"
          @reset="updateNameReset"
        />
      </NomalContainer>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { ElForm, ElMessage, ElMessageBox } from 'element-plus'
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import Container from '@/components/form/container/Container.vue'
import SearchForm from '@/components/form/search/SearchForm.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import CenterForm from '@/components/form/common/CenterForm.vue'
import NomalContainer from '@/components/dfms-components/container/NomalContainer.vue'
import {
  TemplateCategoryUserModel,
  TemplateCategoryUserPageSearchModel,
  TemplateCategoryUserSearchModel,
  TemplateCategoryUserAddModel,
  TemplateCategoryUserUpdateModel,
  IdsModel
} from '@/model/product/TemplateCategoryUserModel'
import {
  pageSearchTemplateCategoryUser,
  addTemplateCategoryUser,
  updateTemplateCategoryUser,
  removeTemplateCategoryUser,
  batchRemoveTemplateCategoryUser
} from '@/apis/product/templateCategoryUser'
import { parseTime } from '@/utils'
import { createModel } from '@/utils/component'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: {
    Container,
    SearchForm,
    SimpleTable,
    CenterForm,
    NomalContainer
  },
  setup() {
    const { t } = useI18n()
    const searchFormRef = ref(ElForm)
    const searchStruct = [
      { prop: 'categoryName', label: t('templateCategoryUser.categoryName'), placeholder: t('templateCategoryUser.categoryNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'userId', label: t('templateCategoryUser.userId'), placeholder: t('templateCategoryUser.userIdP'), component: 'el-input', type: 'number', model: null },
      { prop: 'clientId', label: t('templateCategoryUser.clientId'), placeholder: t('templateCategoryUser.clientIdP'), component: 'el-input', type: 'text', model: null }
    ]

    const createStruct = [
      { prop: 'categoryName', label: t('templateCategoryUser.categoryName'), placeholder: t('templateCategoryUser.categoryNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'userId', label: t('templateCategoryUser.userId'), placeholder: t('templateCategoryUser.userIdP'), component: 'el-input', type: 'number', model: null },
      { prop: 'displayOrder', label: t('templateCategoryUser.displayOrder'), placeholder: t('templateCategoryUser.displayOrderP'), component: 'el-input', type: 'number', model: null },
      { prop: 'clientId', label: t('templateCategoryUser.clientId'), placeholder: t('templateCategoryUser.clientIdP'), component: 'el-input', type: 'text', model: null }
    ]

    const updateStruct = [
      { prop: 'categoryName', label: t('templateCategoryUser.categoryName'), placeholder: t('templateCategoryUser.categoryNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'userId', label: t('templateCategoryUser.userId'), placeholder: t('templateCategoryUser.userIdP'), component: 'el-input', type: 'number', model: null },
      { prop: 'displayOrder', label: t('templateCategoryUser.displayOrder'), placeholder: t('templateCategoryUser.displayOrderP'), component: 'el-input', type: 'number', model: null },
      { prop: 'clientId', label: t('templateCategoryUser.clientId'), placeholder: t('templateCategoryUser.clientIdP'), component: 'el-input', type: 'text', model: null }
    ]

    const templateCategoryUserRole = {
      categoryName: [{ required: true, message: t('templateCategoryUser.categoryName').concat(t('common.isRequired')), trigger: 'blur' }],
      userId: [{ required: true, message: t('templateCategoryUser.userId').concat(t('common.isRequired')), trigger: 'blur' }],
      displayOrder: [{ required: true, message: t('templateCategoryUser.displayOrder').concat(t('common.isRequired')), trigger: 'blur' }],
      clientId: [{ required: true, message: t('templateCategoryUser.clientId').concat(t('common.isRequired')), trigger: 'blur' }]
    }

    const tableStruct = [

      { prop: 'categoryName', label: t('templateCategoryUser.categoryName'), sortable: 'custom' },
      { prop: 'userId', label: t('templateCategoryUser.userId'), sortable: 'custom' },
      { prop: 'displayOrder', label: t('templateCategoryUser.displayOrder'), sortable: 'custom' },
      { prop: 'clientId', label: t('templateCategoryUser.clientId'), sortable: 'custom' },
      { prop: 'createTime', label: t('common.createTime'), formatter: (row: TemplateCategoryUserModel) => { return parseTime(row.createTime) }, sortable: 'custom' },
      { prop: 'updateTime', label: t('common.updateTime'), formatter: (row: TemplateCategoryUserModel) => { return parseTime(row.updateTime) }, sortable: 'custom' }
    ]
    const dataMap = reactive({
      searchFormStruct: searchStruct,
      searchFormModel: createModel(searchStruct) as TemplateCategoryUserSearchModel,
      tableData: Array<TemplateCategoryUserModel>(),
      columnStruct: tableStruct,
      listLoading: true,
      selection: Array<number>(),
      limit: 10,
      total: 0,
      page: 1,
      sort: 'createTime',
      order: 'desc',
      dialogStatus: 'create',
      textMap: {
        update: 'templateCategoryUser.edit',
        create: 'templateCategoryUser.create'
      },
      dialogFormVisible: false,
      templateCategoryUserRole: templateCategoryUserRole,
      createStruct: createStruct,
      createModel: createModel(createStruct) as TemplateCategoryUserAddModel,
      updateStruct: updateStruct,
      updateModel: createModel(updateStruct) as TemplateCategoryUserUpdateModel,
      editRow: {} as TemplateCategoryUserModel,
      handleSelection(item: any[]) {
        dataMap.selection = item
      },
      handleCurrentChange(page?: any) {
        dataMap.page = page
        dataMap.getList()
      },
      handleSizeChange(val: any) {
        dataMap.limit = val
        dataMap.getList()
      },
      handleOrder(column: any) {
        dataMap.sort = column.prop
        dataMap.order = column.order === 'descending' ? 'desc' : 'asc'
        dataMap.getList()
      },
      async getList() {
        dataMap.listLoading = true
        const params: TemplateCategoryUserPageSearchModel = {
          categoryName: dataMap.searchFormModel.categoryName,
          userId: dataMap.searchFormModel.userId,
          displayOrder: dataMap.searchFormModel.displayOrder,
          clientId: dataMap.searchFormModel.clientId,
          page: dataMap.page,
          limit: dataMap.limit,
          sort: dataMap.sort,
          order: dataMap.order
        }
        const data = await pageSearchTemplateCategoryUser(params)
        dataMap.tableData = data?.data?.records ?? []
        const total = data?.data?.total ?? '0'
        dataMap.total = parseInt(total)

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      submitSearch() {
        dataMap.page = 1
        dataMap.getList()
      },
      resetForm() {
        console.log('reset')
      },
      async createSubmit() {
        const createData: TemplateCategoryUserAddModel = {
          categoryName: dataMap.createModel.categoryName,
          userId: dataMap.createModel.userId,
          displayOrder: dataMap.createModel.displayOrder,
          clientId: dataMap.createModel.clientId
        }
        const result = await addTemplateCategoryUser(createData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.createSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async updateNameSubmit() {
        const updateData: TemplateCategoryUserUpdateModel = {
          id: dataMap.updateModel.id,
          categoryName: dataMap.updateModel.categoryName,
          userId: dataMap.updateModel.userId,
          displayOrder: dataMap.updateModel.displayOrder,
          clientId: dataMap.updateModel.clientId
        }
        const result = await updateTemplateCategoryUser(updateData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.updateSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async deleteData(id: number) {
        const result = await removeTemplateCategoryUser(id)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async bathDeleteData() {
        const deleteData: IdsModel = { ids: dataMap.selection }
        const result = await batchRemoveTemplateCategoryUser(deleteData)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      updateNameReset() {
        console.log('update reset')
        dataMap.updateModel.id = dataMap.editRow.id
        dataMap.updateModel.categoryName = dataMap.editRow.categoryName
        dataMap.updateModel.userId = dataMap.editRow.userId
        dataMap.updateModel.displayOrder = dataMap.editRow.displayOrder
        dataMap.updateModel.clientId = dataMap.editRow.clientId
      },
      createReset() {
        console.log('create reset')
      }
    })
    const handleCreate = () => {
      dataMap.dialogStatus = 'create'
      dataMap.dialogFormVisible = true
    }
    const handleEdit = (row?: TemplateCategoryUserModel) => {
      if (row) {
        dataMap.editRow = row
        dataMap.dialogStatus = 'update'
        dataMap.updateModel.id = row.id
        dataMap.updateModel.categoryName = row.categoryName
        dataMap.updateModel.userId = row.userId
        dataMap.updateModel.displayOrder = row.displayOrder
        dataMap.updateModel.clientId = row.clientId
        dataMap.dialogFormVisible = true
      }
    }
    const handleDelete = (id: number) => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.deleteData(id)
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleBathDelete = () => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.bathDeleteData()
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    onMounted(() => {
      dataMap.getList()
    })
    return {
      t,
      handleCreate,
      handleEdit,
      handleDelete,
      handleBathDelete,
      searchFormRef,
      ...toRefs(dataMap)
    }
  }
})
</script>
